<template>
  <el-dialog :visible.sync="state" title="投放数据录入" width="640px" :close-on-click-modal="false" :show-close="false">
    <div>
      <el-form label-width="140px">
        <el-form-item label="投放计划" style="height: 32px">
          <el-tooltip :content="planInfo.planName" placement="top" effect="dark">
            <div style="width: 240px; overflow-x: hidden; text-overflow: ellipsis; white-space: nowrap">
              <span>{{ planInfo.planName }}</span>
            </div>
          </el-tooltip>
        </el-form-item>
        <el-form-item label="投放时间">
          <el-date-picker
            v-model="landData.reportDate"
            :picker-options="datetimeOption"
            :clearable="false"
            type="date"
            placeholder="请选择"
            style="width: 240px"
            value-format="yyyy-MM-dd"
          />
        </el-form-item>
        <el-form-item label="点击量">
          <el-input-number
            :max="99999999"
            :min="0"
            :controls="false"
            v-model.trim="landData.clickNum"
            placeholder="请输入点击量"
            style="width: 240px"
            @blur="inputTrim('clickNum', landData.clickNum, landData, false, 0)"
          />
        </el-form-item>
        <el-form-item label="曝光量">
          <el-input-number
            :max="99999999"
            :min="0"
            :controls="false"
            v-model.trim="landData.pv"
            placeholder="请输入曝光量"
            style="width: 240px"
            @blur="inputTrim('pv', landData.pv, landData, false, 0)"
          />
        </el-form-item>
        <el-form-item label="点击率">
          <el-input-number
            disabled
            :controls="false"
            v-model.trim="clickRate"
            placeholder="输入点击和曝光后自动计算"
            style="width: 240px"
          />
          <span>&nbsp;%</span>
        </el-form-item>
        <el-form-item label="账面消耗">
          <el-input-number
            :max="99999999.99"
            :min="0"
            :controls="false"
            v-model.trim="landData.paperUseAmount"
            placeholder="请输入账面消耗"
            style="width: 240px"
            @blur="inputTrim('paperUseAmount', landData.paperUseAmount, landData, true, 2)"
          />
          <span>&nbsp;元</span>
        </el-form-item>
        <el-form-item label="赠款消耗">
          <el-input-number
            :max="99999999.99"
            :min="0"
            :controls="false"
            v-model.trim="landData.giveAmount"
            placeholder="请输入赠款消耗"
            style="width: 240px"
            @blur="inputTrim('giveAmount', landData.giveAmount, landData, true, 2)"
          />
          <span>&nbsp;元</span>
        </el-form-item>
        <el-form-item label="投放明细">
          <el-table :data="planData" height="200" border class="common-el-table-styles">
            <el-table-column prop="tdate" label="数据时间" width="98" show-overflow-tooltip />
            <el-table-column prop="clickNum" label="点击量" width="75" show-overflow-tooltip />
            <el-table-column prop="pv" label="曝光量" width="75" show-overflow-tooltip />
            <el-table-column prop="paperUseAmount" label="账面消耗" show-overflow-tooltip />
            <el-table-column prop="giveAmount" label="赠款消耗" show-overflow-tooltip />
          </el-table>
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="m-foot">
      <el-button @click="closeModal">关闭</el-button>
      <el-button type="primary" :loading="loading" @click="update"> 录入 </el-button>
    </span>
  </el-dialog>
</template>

<script>
import moment from 'moment'
import { isEmpty, trim, deepCopy } from '@/common/js/utils'
import { addPtomData, getPtomData } from '@/api/track.plan.model'

const landData = {
  clickNum: '',
  pv: '',
  paperUseAmount: '',
  giveAmount: '',
  reportDate: moment().format('YYYY-MM-DD')
}

export default {
  name: 'quickDebug',
  props: {
    value: {
      type: Boolean
    },
    planInfo: {
      type: Object
    }
  },
  computed: {
    state: {
      get() {
        if (this.value) this.getData()
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    },
    clickRate: {
      get() {
        const pv = this.landData.pv || 1
        return ((this.landData.clickNum / pv) * 100).toFixed(2)
      },
      set(val) {}
    }
  },
  methods: {
    update() {
      const { planId } = this.planInfo
      const params = { planId }
      Object.assign(params, this.landData, { reportDate: moment(this.landData.reportDate).format('YYYY-MM-DD') })
      this.loading = true
      addPtomData(params).then((data) => {
        this.loading = false
        if (data && this.value) {
          this.closeModal()
          this.$Message.success('录入成功')
          this.$emit('on-refresh')
        }
      })
    },
    getData() {
      getPtomData({ planId: this.planInfo.planId }).then((data) => {
        if (data) {
          this.planData = data.map((ret) => {
            ret.tdate = moment(ret.tdate).format('YYYY-MM-DD')
            return ret
          })
        }
      })
    },

    inputTrim(key, val, obj, fixed, precision = 2) {
      if (isEmpty(val)) return val
      val = Number(trim(val))
      if (fixed) {
        val = val.toFixed(precision)
      } else val = parseInt(val)
      obj[key] = isEmpty(val) ? 0 : val
    },
    closeModal() {
      this.$emit('input', false)
      this.landData = deepCopy(landData)
    }
  },
  data() {
    return {
      loading: false,
      landData: deepCopy(landData),
      datetimeOption: {
        disabledDate(date) {
          return date && date.valueOf() > Date.now()
        }
      },
      planData: []
    }
  },
  created() {}
}
</script>

<style lang="scss" scoped>
::v-deep.el-input-number {
  input {
    text-align: left;
  }
}
</style>
